export default function LimitedEditionIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M366.04,383.34c21.28-10.92,60.28-21.58,60.92-45.41.64-23.83,1.67-28.53,7.21-43.24,5.53-14.71-3.09-16.6-8.26-35.63-5.17-19.03,16.67-62.47,6.35-83.53-10.31-21.06-36.95-13.36-47.2-50.38-10.87-39.27-33.28-50.47-50.05-59.1-23.69-12.19-40.77,12.91-57.6,7.61-54.89-17.28-81.01-20.04-97.36,2.67-20.81,28.91-32.73,22.69-57.24,28.13-24.51,5.45-18.33,17.82-28.77,49.68-10.45,31.85-34.64,23.43-22.41,64.18,8.14,27.13-14.93,58.22-5.09,100.85,9.84,42.63,37.18,24.37,52.97,43.8,26.49,32.6,18.34,43.8,35.45,57.7,33.2,26.96,55,18.65,63.6,16.11,8.6-2.54,27.13-15.1,41.29-6.36s16.53-6.33,44.04,3.85c27.02,10.01,40.86-40.01,62.14-50.93ZM98.98,285.4c-21.14-83.72,29.59-168.71,113.3-189.85,83.72-21.14,168.71,29.58,189.85,113.3,21.14,83.71-29.58,168.71-113.3,189.85-83.71,21.14-168.71-29.59-189.85-113.3Z" />
      <path d="M247.82,109.54c-74.86,0-135.54,60.68-135.54,135.54s60.68,135.54,135.54,135.54,135.54-60.68,135.54-135.54-60.68-135.54-135.54-135.54ZM247.82,368.61c-68.22,0-123.54-55.31-123.54-123.54s55.31-123.54,123.54-123.54,123.54,55.31,123.54,123.54-55.31,123.54-123.54,123.54Z" />
      <circle cx="247.82" cy="245.08" r="123.54" transform="translate(-100.71 247.01) rotate(-45)" opacity=".20" />
      <polygon 
        className="le-text"
        points="203.69 204.16 184.72 204.16 184.72 285.62 244.31 285.62 244.31 270.26 203.69 270.26 203.69 204.16" 
      />
      <polygon 
        className="le-text"
        points="273.75 270.49 273.75 251.64 311.57 251.64 311.57 236.86 273.75 236.86 273.75 219.28 316.57 219.28 316.57 204.16 255.01 204.16 255.01 285.62 318.09 285.62 318.09 270.49 273.75 270.49" 
      />
    </svg>
  );
}
